import http,{responsePromiseChainHandler} from "../sitel/commons/services/http";
import { perculator } from "./authCentral";

/**
 * Create a temp user with email and password
 */
export function createTempUser(
    origin_app,
    medstar_association_type,
    firstName,
    lastName,
    email,
    sesame1,
    successCallback,
    errorCallback){
    responsePromiseChainHandler(http.post('/tmpuser', { firstName, lastName, email, sesame1: perculator(sesame1), origin_app, medstar_association_type }),successCallback,errorCallback); 
}

/**
 * Gets the list of Vendors to show in forms
 */
export function vendorList(successCallback,errorCallback){
    responsePromiseChainHandler(http.get('/vendors'),successCallback,errorCallback);
}

/**
 * fetch the user's profile
 */
export function getProfile(userId,successCallback,errorCallback){
    responsePromiseChainHandler(http.get(`/profile/user_id/${userId}`),successCallback,errorCallback);
}

/**
 * Send the profile 
 */
export function createProfile(medstarAssociationType,profile,successCallback,errorCallback){
    responsePromiseChainHandler(http.post(`/profile/medstar_association_type/${medstarAssociationType}`,{...profile}),successCallback,errorCallback);
}

/**
 * Update the profile 
 */
export function updateProfile(medstarAssociationType,profile,successCallback,errorCallback){
    responsePromiseChainHandler(http.put(`/profile/medstar_association_type/${medstarAssociationType}`,{...profile}),successCallback,errorCallback);
}

//curl -vk -X GET "https://localhost/demonhead/central/credentials" -d '{"params":{"path":"oh-requests","username":"temporal2@gmail.com"}}'
export function startPasswordReset(path,username,successCallback,errorCallback){
    responsePromiseChainHandler(http.post("/credentials",{params:{path,username}}),successCallback,errorCallback);
}



/**
 * Submits to an authenticated link the new password
 * 
 * @param {string} newSesame 
 * @param {Callback} successCallback 
 * @param {Callback} errorCallback 
 */
export function finishPasswordReset(newSesame,successCallback,errorCallback){
    responsePromiseChainHandler(http.patch("/credentials",{params: {newSesame: perculator(newSesame)} }),successCallback,errorCallback);
}


export function getNewAccessToken(successCallback,errorCallback){
    responsePromiseChainHandler(http.put(`/opal`),successCallback,errorCallback);
}
